import DsvModalShell from "./DsvModalShell";
import PropTypes from 'prop-types';
import rem from "@/utils/rem.js";

/**
 * Confirm dialog for removing a use-case-persona link from a data element.
 * Follows the same DsvModalShell pattern as DeleteVersionModal. The backend
 * returns 406 when the link is still in use (active subscriptions / enrolments),
 * so the copy warns about that.
 */
function UnlinkUseCaseModal({ visible, hide, target, onConfirm }) {
	if (!target) return null;

	return (
		<DsvModalShell
			visible={visible}
			hide={hide}
			title="Remove Use Case Link"
			actions={
				<button
					className="dsv-btn dsv-btn--retire"
					style={{ marginLeft: rem(12) }}
					data-testid="confirm-unlink-btn"
					onClick={() => onConfirm(target)}
				>
					Remove
				</button>
			}
		>
			<p className="dsv-confirm__subtitle">
				Remove the link between <strong>{target.personaName}</strong> and{' '}
				<strong>{target.useCaseName}</strong>?
			</p>
			<p className="dsv-promote__hint">
				This can&apos;t be undone. Removal is blocked if active subscriptions,
				enrolments or verification flows still use this link.
			</p>
		</DsvModalShell>
	);
}

UnlinkUseCaseModal.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func,
	target: PropTypes.object,
	onConfirm: PropTypes.func,
};

export default UnlinkUseCaseModal;
